import { i as implementation$1 } from './implementation.js';

var implementation = implementation$1;

var polyfill = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};

export { polyfill as p };
